<template>
  <label class="c-profile-upload" for="file">
    <slot></slot>
    <input id="file" type="file" @change="onFileChange" accept=".json" />
  </label>
</template>
<script>
import profileDefault from "@/assets/profile-default.json";
import { speedList } from "@/utils";

export default {
  name: "CProfileUpload",
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onerror = reject;
          fileReader.onload = (e) => {
            try {
              const data = JSON.parse(e.target.result);
              if (
                (data &&
                  data.keyboardSettings &&
                  data.lightEffects &&
                  data.lightEffects.length > 0) ||
                (data && data.page_data && data.page_data.length > 0)
              ) {
                resolve(data);
              } else {
                reject();
              }
            } catch (error) {
              reject(error);
            }
          };
          fileReader.readAsText(file);
        })
          .then((data) => {
            if (data.keyboardSettings) {
              this.$emit("upload", { name: file.name.split(".")[0], data });
            } else {
              this.uploadR2Profile(file.name.split(".")[0], data);
            }
            e.target.value = null;
          })
          .catch((error) => {
            console.error(error);
            e.target.value = null;
            this.$info({
              title: this.$t("index.fileErrorInfo"),
              width: "8.4rem",
              okText: this.$t("yes"),
              cancelText: this.$t("cancel"),
              centered: true,
            });
          });
      }
    },
    uploadR2Profile(name, data) {
      const { page_data, key_layer } = data;
      let { lightEffects } = profileDefault;

      lightEffects[4].frames = this.getFrames(page_data[5].frames.frame_data);
      lightEffects[4].speed.value =
        speedList.findIndex((speed) => speed === page_data[5].speed_ms) + 1;
      lightEffects[11].frames = this.getKeyFrames(
        page_data[5].keyframes.frame_data
      );
      lightEffects[11].speed.value = lightEffects[4].speed.value;

      lightEffects[5].frames = this.getFrames(page_data[6].frames.frame_data);
      lightEffects[5].speed.value =
        speedList.findIndex((speed) => speed === page_data[6].speed_ms) + 1;
      lightEffects[12].frames = this.getKeyFrames(
        page_data[6].keyframes.frame_data
      );
      lightEffects[12].speed.value = lightEffects[5].speed.value;

      lightEffects[6].frames = this.getFrames(page_data[7].frames.frame_data);
      lightEffects[6].speed.value =
        speedList.findIndex((speed) => speed === page_data[7].speed_ms) + 1;
      lightEffects[13].frames = this.getKeyFrames(
        page_data[7].keyframes.frame_data
      );
      lightEffects[13].speed.value = lightEffects[6].speed.value;

      this.$emit("upload", {
        name,
        data: {
          ...profileDefault,
          lightEffects,
          ...this.getKeys(key_layer),
        },
      });
    },
    getFrames(frames) {
      let frameData = [];
      frames.map((frame, index) => {
        let frameRGB = [];
        for (let i = 0; i < 40; i++) {
          for (let j = 0; j < 5; j++) {
            frameRGB.push(frame.frame_RGB[j * 40 + i]);
          }
        }
        frameData.push({
          frameRGB,
          frameIndex: index + 1,
        });
      });
      return frameData;
    },
    getKeyFrames(frames) {
      frames.map((frame) => {
        let frameRGB = new Array(84);
        frameRGB[0] = frame.frame_RGB[0];
        frameRGB[1] = frame.frame_RGB[0];
        frameRGB[2] = frame.frame_RGB[1];
        frameRGB[3] = frame.frame_RGB[2];
        frameRGB[4] = frame.frame_RGB[3];
        frameRGB[5] = frame.frame_RGB[4];
        frameRGB[6] = frame.frame_RGB[5];
        frameRGB[7] = frame.frame_RGB[6];
        frameRGB[8] = frame.frame_RGB[7];
        frameRGB[9] = frame.frame_RGB[8];
        frameRGB[10] = frame.frame_RGB[9];
        frameRGB[11] = frame.frame_RGB[10];
        frameRGB[12] = frame.frame_RGB[11];
        frameRGB[13] = frame.frame_RGB[12];
        frameRGB[14] = frame.frame_RGB[13];
        frameRGB[70] = frame.frame_RGB[14];

        frameRGB[15] = frame.frame_RGB[15];
        frameRGB[16] = frame.frame_RGB[16];
        frameRGB[17] = frame.frame_RGB[17];
        frameRGB[18] = frame.frame_RGB[18];
        frameRGB[19] = frame.frame_RGB[19];
        frameRGB[20] = frame.frame_RGB[20];
        frameRGB[21] = frame.frame_RGB[21];
        frameRGB[22] = frame.frame_RGB[22];
        frameRGB[23] = frame.frame_RGB[23];
        frameRGB[24] = frame.frame_RGB[24];
        frameRGB[25] = frame.frame_RGB[25];
        frameRGB[26] = frame.frame_RGB[26];
        frameRGB[27] = frame.frame_RGB[27];
        frameRGB[28] = frame.frame_RGB[28];
        frameRGB[69] = frame.frame_RGB[29];

        frameRGB[29] = frame.frame_RGB[30];
        frameRGB[30] = frame.frame_RGB[31];
        frameRGB[31] = frame.frame_RGB[32];
        frameRGB[32] = frame.frame_RGB[33];
        frameRGB[33] = frame.frame_RGB[34];
        frameRGB[34] = frame.frame_RGB[35];
        frameRGB[35] = frame.frame_RGB[36];
        frameRGB[36] = frame.frame_RGB[37];
        frameRGB[37] = frame.frame_RGB[38];
        frameRGB[38] = frame.frame_RGB[39];
        frameRGB[39] = frame.frame_RGB[40];
        frameRGB[40] = frame.frame_RGB[41];
        frameRGB[41] = frame.frame_RGB[42];
        frameRGB[42] = frame.frame_RGB[43];
        frameRGB[68] = frame.frame_RGB[44];

        frameRGB[43] = frame.frame_RGB[45];
        frameRGB[44] = frame.frame_RGB[46];
        frameRGB[45] = frame.frame_RGB[47];
        frameRGB[46] = frame.frame_RGB[48];
        frameRGB[47] = frame.frame_RGB[49];
        frameRGB[48] = frame.frame_RGB[50];
        frameRGB[49] = frame.frame_RGB[51];
        frameRGB[50] = frame.frame_RGB[52];
        frameRGB[51] = frame.frame_RGB[53];
        frameRGB[52] = frame.frame_RGB[54];
        frameRGB[53] = frame.frame_RGB[55];
        frameRGB[54] = frame.frame_RGB[56];
        frameRGB[55] = frame.frame_RGB[58];
        frameRGB[56] = frame.frame_RGB[59];

        frameRGB[57] = frame.frame_RGB[60];
        frameRGB[58] = frame.frame_RGB[62];
        frameRGB[59] = frame.frame_RGB[63];
        frameRGB[60] = frame.frame_RGB[64];
        frameRGB[61] = frame.frame_RGB[65];
        frameRGB[62] = frame.frame_RGB[66];
        frameRGB[63] = frame.frame_RGB[67];
        frameRGB[64] = frame.frame_RGB[68];
        frameRGB[65] = frame.frame_RGB[69];
        frameRGB[66] = frame.frame_RGB[70];
        frameRGB[67] = frame.frame_RGB[71];
        frameRGB[82] = frame.frame_RGB[72];
        frameRGB[83] = frame.frame_RGB[73];

        frameRGB[71] = frame.frame_RGB[75];
        frameRGB[72] = frame.frame_RGB[76];
        frameRGB[73] = frame.frame_RGB[77];
        frameRGB[74] = frame.frame_RGB[79];
        frameRGB[75] = frame.frame_RGB[80];
        frameRGB[76] = frame.frame_RGB[81];
        frameRGB[77] = frame.frame_RGB[85];
        frameRGB[78] = frame.frame_RGB[86];
        frameRGB[79] = frame.frame_RGB[87];
        frameRGB[80] = frame.frame_RGB[88];
        frameRGB[81] = frame.frame_RGB[89];

        frame.frame_RGB = frameRGB;
      });

      let frameData = [];

      frames.map((frame) => {
        frame.frame_RGB.map((RGB) => {
          if (
            !frameData[frameData.length - 1] ||
            frameData[frameData.length - 1].frameRGB.length === 200
          ) {
            frameData.push({
              frameIndex: frameData.length + 1,
              frameRGB: [],
            });
          }
          frameData[frameData.length - 1].frameRGB.push(RGB);
        });
      });

      return frameData;
    },
    getKeys(key_layer) {
      const keyList = [
        { r1: "key_esc", r2: "#00070029", r2Index: 0 },
        { r1: "key_f1", r2: "#0007003A", r2Index: 1 },
        { r1: "key_f2", r2: "#0007003B", r2Index: 2 },
        { r1: "key_f3", r2: "#0007003C", r2Index: 3 },
        { r1: "key_f4", r2: "#0007003D", r2Index: 4 },
        { r1: "key_f5", r2: "#0007003E", r2Index: 5 },
        { r1: "key_f6", r2: "#0007003F", r2Index: 6 },
        { r1: "key_f7", r2: "#00070040", r2Index: 7 },
        { r1: "key_f8", r2: "#00070041", r2Index: 8 },
        { r1: "key_f9", r2: "#00070042", r2Index: 9 },
        { r1: "key_f10", r2: "#00070043", r2Index: 10 },
        { r1: "key_f11", r2: "#00070044", r2Index: 11 },
        { r1: "key_f12", r2: "#00070045", r2Index: 12 },
        { r1: "key_delete", r2: "#0007004C", r2Index: 13 },
        { r1: "key_home", r2: "#0007004A", r2Index: 14 },

        { r1: "key_GAT", r2: "#00070035", r2Index: 25 },
        { r1: "key_1", r2: "#0007001E", r2Index: 26 },
        { r1: "key_2", r2: "#0007001F", r2Index: 27 },
        { r1: "key_3", r2: "#00070020", r2Index: 28 },
        { r1: "key_4", r2: "#00070021", r2Index: 29 },
        { r1: "key_5", r2: "#00070022", r2Index: 30 },
        { r1: "key_6", r2: "#00070023", r2Index: 31 },
        { r1: "key_7", r2: "#00070024", r2Index: 32 },
        { r1: "key_8", r2: "#00070025", r2Index: 33 },
        { r1: "key_9", r2: "#00070026", r2Index: 34 },
        { r1: "key_0", r2: "#00070027", r2Index: 35 },
        { r1: "key_mis", r2: "#0007002D", r2Index: 36 },
        { r1: "key_equ", r2: "#0007002E", r2Index: 37 },
        { r1: "key_backspace", r2: "#0007002A", r2Index: 38 },
        { r1: "key_end", r2: "#0007004D", r2Index: 39 },

        { r1: "key_tab", r2: "#0007002B", r2Index: 50 },
        { r1: "key_q", r2: "#00070014", r2Index: 51 },
        { r1: "key_w", r2: "#0007001A", r2Index: 52 },
        { r1: "key_e", r2: "#00070008", r2Index: 53 },
        { r1: "key_r", r2: "#00070015", r2Index: 54 },
        { r1: "key_t", r2: "#00070017", r2Index: 55 },
        { r1: "key_y", r2: "#0007001C", r2Index: 56 },
        { r1: "key_u", r2: "#00070018", r2Index: 57 },
        { r1: "key_i", r2: "#0007000C", r2Index: 58 },
        { r1: "key_o", r2: "#00070012", r2Index: 59 },
        { r1: "key_p", r2: "#00070013", r2Index: 60 },
        { r1: "key_oqo", r2: "#0007002F", r2Index: 61 },
        { r1: "key_eqo", r2: "#00070030", r2Index: 62 },
        { r1: "key_bsl", r2: "#00070031", r2Index: 63 },
        { r1: "key_pgup", r2: "#0007004B", r2Index: 64 },

        { r1: "key_cap", r2: "#00070039", r2Index: 75 },
        { r1: "key_a", r2: "#00070004", r2Index: 76 },
        { r1: "key_s", r2: "#00070016", r2Index: 77 },
        { r1: "key_d", r2: "#00070007", r2Index: 78 },
        { r1: "key_f", r2: "#00070009", r2Index: 79 },
        { r1: "key_g", r2: "#0007000A", r2Index: 80 },
        { r1: "key_h", r2: "#0007000B", r2Index: 81 },
        { r1: "key_j", r2: "#0007000D", r2Index: 82 },
        { r1: "key_k", r2: "#0007000E", r2Index: 83 },
        { r1: "key_l", r2: "#0007000F", r2Index: 84 },
        { r1: "key_COL", r2: "#00070033", r2Index: 85 },
        { r1: "key_CC", r2: "#00070034", r2Index: 86 },
        { r1: "key_enter", r2: "#00070028", r2Index: 88 },
        { r1: "key_pgdn", r2: "#0007004E", r2Index: 89 },

        { r1: "key_shift_l", r2: "#000700E1", r2Index: 100 },
        { r1: "key_z", r2: "#0007001D", r2Index: 102 },
        { r1: "key_x", r2: "#0007001B", r2Index: 103 },
        { r1: "key_c", r2: "#00070006", r2Index: 104 },
        { r1: "key_v", r2: "#00070019", r2Index: 105 },
        { r1: "key_b", r2: "#00070005", r2Index: 106 },
        { r1: "key_n", r2: "#00070011", r2Index: 107 },
        { r1: "key_m", r2: "#00070010", r2Index: 108 },
        { r1: "key_CMA", r2: "#00070036", r2Index: 109 },
        { r1: "key_DOT", r2: "#00070037", r2Index: 110 },
        { r1: "key_SL", r2: "#00070038", r2Index: 111 },
        { r1: "key_shift_r", r2: "#000700E5", r2Index: 112 },
        { r1: "key_up", r2: "#00070052", r2Index: 113 },

        { r1: "key_ctrl_l", r2: "#000700E0", r2Index: 125 },
        { r1: "key_win_l", r2: "#000700E3", r2Index: 126 },
        { r1: "key_alt_l", r2: "#000700E2", r2Index: 127 },
        { r1: "key_space", r2: "#0007002C", r2Index: 131 },
        { r1: "KEY_FN", r2: "#00920C0B", r2Index: 135 },
        { r1: "key_ctrl_r", r2: "#000700E4", r2Index: 136 },
        { r1: "key_left", r2: "#00070050", r2Index: 137 },
        { r1: "key_down", r2: "#00070051", r2Index: 138 },
        { r1: "key_right", r2: "#0007004F", r2Index: 139 },

        { r1: "key_app", r2: "#00070065", r2Index: -1 },
        { r1: "key_print", r2: "#00070046", r2Index: -1 },
        { r1: "key_scroll", r2: "#00070047", r2Index: -1 },
        { r1: "key_pause", r2: "#00070048", r2Index: -1 },
        { r1: "key_insert", r2: "#00070049", r2Index: -1 },
        { r1: "key_numlock", r2: "#00070053", r2Index: -1 },
        { r1: "key_num_PADNSL", r2: "#00070054", r2Index: -1 },
        { r1: "key_num_PADNMU", r2: "#00070055", r2Index: -1 },
        { r1: "key_num_PADNMI", r2: "#00070056", r2Index: -1 },
        { r1: "key_num_PADNPL", r2: "#00070057", r2Index: -1 },
        { r1: "key_num_enter", r2: "#00070058", r2Index: -1 },
        { r1: "key_num_1", r2: "#00070059", r2Index: -1 },
        { r1: "key_num_2", r2: "#0007005A", r2Index: -1 },
        { r1: "key_num_3", r2: "#0007005B", r2Index: -1 },
        { r1: "key_num_4", r2: "#0007005C", r2Index: -1 },
        { r1: "key_num_5", r2: "#0007005D", r2Index: -1 },
        { r1: "key_num_6", r2: "#0007005E", r2Index: -1 },
        { r1: "key_num_7", r2: "#0007005F", r2Index: -1 },
        { r1: "key_num_8", r2: "#00070060", r2Index: -1 },
        { r1: "key_num_9", r2: "#00070061", r2Index: -1 },
        { r1: "key_num_0", r2: "#00070062", r2Index: -1 },
        { r1: "key_num_del", r2: "#00070063", r2Index: -1 },
        { r1: "key_alt_r", r2: "#000700E6", r2Index: -1 },
        { r1: "key_win_r", r2: "#000700E7", r2Index: -1 },

        { r1: "key_local_key_fun_switch_left", r2: "#00920C0D", r2Index: -1 },
        { r1: "key_led_cmd_on_off_led", r2: "#00920101", r2Index: -1 },
        { r1: "key_led_cmd_next_page", r2: "#00920100", r2Index: -1 },
        { r1: "key_led_cmd_lightness_add", r2: "#00920102", r2Index: -1 },
        { r1: "key_led_cmd_lightness_reduce", r2: "#00920103", r2Index: -1 },
        { r1: "key_led_cmd_speed_add", r2: "#00920104", r2Index: -1 },
        { r1: "key_led_cmd_speed_reduce", r2: "#00920105", r2Index: -1 },
        { r1: "key_local_key_mode_cmd_on_off", r2: "#00920903", r2Index: -1 },
        { r1: "key_local_key_next_mode", r2: "#00920900", r2Index: -1 },
        {
          r1: "key_local_key_mode_lightness_add",
          r2: "#00920901",
          r2Index: -1,
        },
        {
          r1: "key_local_key_mode_lightness_reduce",
          r2: "#00920902",
          r2Index: -1,
        },
        { r1: "key_led_cmd_ble_shfit1", r2: "#00920106", r2Index: -1 },
        { r1: "key_led_cmd_ble_shfit2", r2: "#00920107", r2Index: -1 },
        { r1: "key_led_cmd_ble_shfit3", r2: "#00920108", r2Index: -1 },
        { r1: "key_led_cmd_ble_2_4g", r2: "#00920130", r2Index: -1 },
        { r1: "key_led_cmd_factory_reset", r2: "#00920A02", r2Index: -1 },

        { r1: "key_cmd_set_key_layer1", r2: "#00920C0F", r2Index: -1 },
        { r1: "key_cmd_set_key_layer2", r2: "#00920C10", r2Index: -1 },
        { r1: "key_cmd_set_key_layer3", r2: "#00920C11", r2Index: -1 },
        { r1: "key_cmd_set_key_layer4", r2: "#00920C12", r2Index: -1 },
        { r1: "key_cmd_set_key_layer5", r2: "#00920C13", r2Index: -1 },
        { r1: "key_cmd_set_key_layer6", r2: "#00920C14", r2Index: -1 },
        { r1: "key_cmd_set_key_layer7", r2: "#00920C15", r2Index: -1 },

        { r1: "key_hold_set_key_layer1", r2: "#00920C20", r2Index: -1 },
        { r1: "key_hold_set_key_layer3", r2: "#00920C22", r2Index: -1 },
        { r1: "key_hold_set_key_layer4", r2: "#00920C23", r2Index: -1 },
        { r1: "key_hold_set_key_layer5", r2: "#00920C24", r2Index: -1 },
        { r1: "key_hold_set_key_layer6", r2: "#00920C25", r2Index: -1 },
        { r1: "key_hold_set_key_layer7", r2: "#00920C26", r2Index: -1 },

        { r1: "key_media_mute", r2: "#000C00E2", r2Index: -1 },
        { r1: "key_media_volume_up", r2: "#000C00E9", r2Index: -1 },
        { r1: "key_media_volume_down", r2: "#000C00EA", r2Index: -1 },
        { r1: "key_media_prev_track", r2: "#000C00B6", r2Index: -1 },
        { r1: "key_media_next_track", r2: "#000C00B5", r2Index: -1 },
        { r1: "key_media_play_pause", r2: "#000C00CD", r2Index: -1 },

        { r1: "key_led_cmd_power", r2: "#00920A01", r2Index: -1 },
      ];

      let keys = {};

      if (!key_layer || !key_layer.layer_data || !key_layer.layer_data.length) {
        return keys;
      }

      key_layer.layer_data.map(({ layer }, layerIndex) => {
        let layerKeys = [];
        layer.map((key, index) => {
          const input = keyList.find((keyItem) => keyItem.r2Index === index);
          if (input && input.r2 !== key) {
            const out = keyList.find((keyItem) => keyItem.r2 === key);
            layerKeys.push({
              srcKey: input.r1,
              dstKey: out ? out.r1 : input.r1,
            });
          }
        });

        const { keyboardSettings } = profileDefault;

        layerKeys = keyboardSettings.map((key) => {
          const newKey = layerKeys.find(
            (keyItem) => keyItem.srcKey === key.srcKey
          );
          return newKey || key;
        });

        keys["keyboardSettings" + (layerIndex || "")] = layerKeys;
      });

      return keys;
    },
  },
};
</script>
<style lang="scss" scoped>
.c-profile-upload > input {
  display: none;
}
</style>
